// CreateSocietyAdminList.js (fixed design)
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAdmin } from "./APIs/CreateSocietyApi";
import { CSVLink } from "react-csv";
import axios from "axios";
import { BASE_URL } from "./APIs/config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaTrash, FaEdit, FaSignInAlt } from "react-icons/fa";
import {
  FiSearch,
  FiDownload,
  FiX,
  FiCheckCircle,
  FiClock,
} from "react-icons/fi";
import Sidebar from "./Sidebar";
import Header from "./Header";

const CreateSocietyAdminList = () => {
  const [showModal, setShowModal] = useState(false);
  const [societies, setSocieties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [saving, setSaving] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  const headers = [
    { label: "Society Name", key: "society" },
    { label: "Admin", key: "adminName" },
    { label: "Mobile No", key: "adminPhoneNo" },
    { label: "Email ID", key: "adminEmail" },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    const loadSocieties = async () => {
      try {
        const data = await getAdmin();
        setSocieties(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error loading society list:", error);
        toast.error("Failed to load admins.");
      } finally {
        setLoading(false);
      }
    };

    loadSocieties();
  }, []);

  const handleEndDateClick = async (emailId) => {
    setEmail(emailId);
    setShowModal(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) return toast.error("Authorization missing.");

      await axios.post(
        `${BASE_URL}/api/otp/send`,
        { email: emailId },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setOtpSent(true);
      toast.info("OTP sent to admin email.");
    } catch (error) {
      toast.error("Failed to send OTP.");
    }
  };

  const handleVerifyAndSave = async () => {
    try {
      await axios.post(`${BASE_URL}/api/otp/verify`, { email, otp });
      toast.success("Resignation processed.");
      setShowModal(false);
      setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      toast.error("Invalid OTP.");
    }
  };

  const openEditModal = (admin) => {
    setSelectedAdmin({ ...admin });
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setSelectedAdmin(null);
    setEditModalOpen(false);
  };

  const handleEditChange = (field, value) => {
    setSelectedAdmin((prev) => ({ ...prev, [field]: value }));
  };

  const saveAdminChanges = async () => {
    if (!selectedAdmin) return;
    setSaving(true);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Not authenticated. Please login and try again.", {
          position: "bottom-right",
          autoClose: 3000,
        });
        setSaving(false);
        return;
      }

      const adminId = Number(selectedAdmin.societyAdminId);
      const adminName = selectedAdmin.adminName ?? "";
      const societyMember = !!selectedAdmin.societyMember;
      const adminEmail = selectedAdmin.adminEmail ?? "";
      const societyRegistration = selectedAdmin.societyRegistrationNo ?? "";
      const createPassword = selectedAdmin.createPassword ?? "";
      const adminPhoneNo = selectedAdmin.adminPhoneNo
        ? Number(selectedAdmin.adminPhoneNo)
        : null;
      const createPin = selectedAdmin.createPin ?? "";
      const society = selectedAdmin.society ?? "";

      if (!adminId || !adminName || !adminEmail) {
        toast.error(
          "Please ensure Admin ID, Name and Email are present before saving.",
          { position: "bottom-right", autoClose: 3500 },
        );
        setSaving(false);
        return;
      }

      // Create URLSearchParams (form-encoded) as backend expects
      const form = new URLSearchParams();
      form.append("adminId", adminId);
      form.append("adminName", adminName);
      form.append("societyMember", societyMember);
      form.append("adminEmail", adminEmail);
      form.append("societyRegistration", societyRegistration);
      form.append("createPassword", createPassword);
      if (adminPhoneNo !== null) form.append("adminPhoneNo", adminPhoneNo);
      else form.append("adminPhoneNo", "0");
      form.append("createPin", createPin);
      form.append("society", society);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };

      const url = `${BASE_URL}/api/update-admin-by-id`;
      const resp = await axios.post(url, form.toString(), config);

      setSocieties((prev) =>
        prev.map((s) =>
          Number(s.societyAdminId) === adminId ? { ...s, ...selectedAdmin } : s,
        ),
      );
      toast.success("Admin updated successfully", {
        position: "bottom-right",
        autoClose: 3000,
      });
      closeEditModal();
    } catch (err) {
      console.error("Failed to save admin changes:", err);
      const serverMsg =
        err?.response?.data?.message ||
        (typeof err?.response?.data === "string" ? err.response.data : null) ||
        err?.message ||
        "Unknown error";

      if (err.response) {
        console.error("Response status:", err.response.status);
        console.error("Response data:", err.response.data);

        if (err.response.status === 403) {
          toast.error(
            "Authorization failed (403). Please login again or check your permissions.",
            { position: "bottom-right", autoClose: 4000 },
          );
        } else if (err.response.status === 400) {
          toast.error(`Bad request (400). ${serverMsg}`, {
            position: "bottom-right",
            autoClose: 4000,
          });
        } else {
          toast.error(`Server returned ${err.response.status}: ${serverMsg}`, {
            position: "bottom-right",
            autoClose: 4000,
          });
        }
      } else if (err.request) {
        toast.error(
          "No response from server — check network or server status.",
          { position: "bottom-right", autoClose: 4000 },
        );
      } else {
        toast.error(`Error: ${serverMsg}`, {
          position: "bottom-right",
          autoClose: 4000,
        });
      }
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteAdmin = async (adminId) => {
    if (!window.confirm("Delete this admin?")) return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${BASE_URL}/api/delete-society-admin`, {
        params: { societyAdminId: adminId },
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Admin deleted.");
      setSocieties((prev) => prev.filter((s) => s.societyAdminId !== adminId));
    } catch (error) {
      toast.error("Delete failed.");
    }
  };

  const filteredSocieties = societies.filter(
    (s) =>
      s?.society?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s?.adminName?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="flex min-h-screen bg-bg-primary text-text-main font-satoshi transition-colors duration-300">
      <Sidebar />
      <ToastContainer />

      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header />

        <div className="flex-1 overflow-y-auto p-6 md:p-8 relative">
          {/* Background Elements */}
          <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden opacity-30">
            <div className="absolute top-20 right-20 w-[400px] h-[400px] bg-indigo-900/10 rounded-full blur-[120px]"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto space-y-6">
            {/* Actions Toolbar */}
            <div className="flex flex-col md:flex-row justify-between items-end md:items-center gap-4 border-b border-border pb-6">
              <div>
                <h1 className="text-3xl font-clash font-bold text-text-main mb-1">
                  Society Administrators
                </h1>
                <p className="text-text-muted text-sm">
                  Monitor and manage society admin accounts
                </p>
              </div>

              <div className="flex items-center gap-3">
                <div className="relative group">
                  <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted group-focus-within:text-signal-orange transition-colors" />
                  <input
                    type="text"
                    placeholder="Search admins..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2 bg-bg-secondary border border-border rounded focus:border-signal-orange focus:outline-none text-sm w-64 transition-all text-text-main placeholder:text-text-muted"
                  />
                </div>
                <CSVLink
                  data={societies}
                  headers={headers}
                  filename="society-admin-data.csv"
                >
                  <button className="flex items-center gap-2 px-4 py-2 bg-bg-secondary hover:bg-bg-tertiary border border-border rounded text-sm font-medium transition-all group text-text-main">
                    <FiDownload className="group-hover:text-signal-lime" />
                    <span>Export</span>
                  </button>
                </CSVLink>
              </div>
            </div>

            {/* List Content */}
            <div className="bg-bg-secondary rounded border border-border overflow-hidden backdrop-blur-sm">
              {/* Header Row */}
              <div className="grid grid-cols-12 gap-4 p-4 border-b border-border bg-bg-tertiary/50 text-xs font-bold text-text-muted uppercase tracking-wider">
                <div className="col-span-3">Details</div>
                <div className="col-span-3">Contact</div>
                <div className="col-span-2">Start Date</div>
                <div className="col-span-2">End Date</div>
                <div className="col-span-2 text-center">Actions</div>
              </div>

              {/* Rows */}
              <div className="divide-y divide-border">
                {loading ? (
                  <div className="p-8 text-center text-text-muted animate-pulse">
                    Loading admins...
                  </div>
                ) : filteredSocieties.length === 0 ? (
                  <div className="p-8 text-center text-text-muted">
                    No admins found matching your search.
                  </div>
                ) : (
                  filteredSocieties.map((item, i) => (
                    <div
                      key={i}
                      className="grid grid-cols-12 gap-4 p-4 items-center hover:bg-bg-tertiary transition-colors group"
                    >
                      <div className="col-span-3">
                        <div className="font-medium text-text-main group-hover:text-signal-orange transition-colors">
                          {item.adminName}
                        </div>
                        <div className="text-xs text-text-muted mt-0.5 uppercase tracking-wide">
                          {item.society}
                        </div>
                      </div>

                      <div className="col-span-3 text-sm text-text-muted">
                        <div>{item.adminPhoneNo}</div>
                        <div className="text-xs truncate">
                          {item.adminEmail}
                        </div>
                      </div>

                      <div className="col-span-2 text-sm text-text-muted flex items-center gap-2">
                        <FiCheckCircle className="text-signal-lime/50" />
                        {formatDate(item.startDate)}
                      </div>

                      <div className="col-span-2 text-sm text-text-muted flex items-center gap-2">
                        <button
                          onClick={() => handleEndDateClick(item.adminEmail)}
                          className="text-text-main hover:text-signal-orange hover:underline text-xs flex items-center gap-1"
                        >
                          {item.endDate ? (
                            formatDate(item.endDate)
                          ) : (
                            <span className="text-text-muted italic">
                              Set End Date
                            </span>
                          )}
                        </button>
                      </div>

                      <div className="col-span-2 flex  justify-center gap-2 opacity-60 group-hover:opacity-100 transition-opacity">
                        <button
                          onClick={() =>
                            window.open("https://admin.devaccounts.com/")
                          }
                          className="p-2 hover:bg-bg-tertiary rounded text-green-400 transition-colors"
                          title="Login to Admin Portal"
                        >
                          <FaSignInAlt />
                        </button>
                        <button
                          onClick={() => openEditModal(item)}
                          className="p-2 hover:bg-bg-tertiary rounded text-blue-400 transition-colors"
                          title="Edit"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDeleteAdmin(item.societyAdminId)}
                          className="p-2 hover:bg-bg-tertiary rounded text-red-500 transition-colors"
                          title="Delete"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>

        {showModal && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-bg-primary/80 backdrop-blur-sm">
            <div className="bg-bg-secondary border border-border p-6 rounded-lg shadow-xl w-96 animate-reveal">
              <h3 className="text-lg font-clash font-bold text-text-main mb-4 text-center">
                Confirm Resignation Process
              </h3>
              <p className="text-sm text-text-muted text-center mb-6">
                Sending OTP to {email}. Verify to proceed.
              </p>

              {!otpSent ? (
                <div className="flex justify-center gap-4">
                  <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 border border-border rounded text-text-muted hover:text-text-main"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleEndDateClick(email)}
                    className="px-4 py-2 bg-signal-orange text-noir-900 font-bold rounded"
                  >
                    Send OTP
                  </button>
                </div>
              ) : (
                <div className="space-y-4">
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    className="w-full bg-bg-input border border-border rounded p-2 text-text-main text-center tracking-widest"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  <button
                    onClick={handleVerifyAndSave}
                    className="w-full py-2 bg-signal-lime text-noir-900 font-bold rounded"
                  >
                    Verify & Save
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {editModalOpen && selectedAdmin && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-bg-primary/80 backdrop-blur-sm overflow-y-auto">
            <div className="bg-bg-secondary border border-border w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden animate-reveal my-8">
              <div className="flex justify-between items-center mb-6 border-b border-border pb-4 p-6">
                <h2 className="text-xl font-clash font-bold text-text-main">
                  Edit Admin Details
                </h2>
                <button onClick={closeEditModal}>
                  <FiX
                    className="text-text-muted hover:text-text-main"
                    size={24}
                  />
                </button>
              </div>

              <div className="px-6 pb-6 space-y-6">
                {/* Society Information Section - GREYED OUT / READ-ONLY */}
                <div className="border border-border rounded-lg p-4 bg-bg-tertiary/30">
                  <h3 className="text-sm font-bold text-text-muted uppercase mb-3 flex items-center gap-2">
                    <FiCheckCircle className="text-signal-lime/50" />
                    Society Information (View Only)
                  </h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        Society Name
                      </label>
                      <input
                        type="text"
                        value={selectedAdmin.society || ""}
                        disabled
                        className="w-full bg-bg-input/50 border border-border rounded px-3 py-2 text-text-muted cursor-not-allowed opacity-60"
                      />
                    </div>
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        Society Registration No
                      </label>
                      <input
                        type="text"
                        value={selectedAdmin.societyRegistrationNo || "N/A"}
                        disabled
                        className="w-full bg-bg-input/50 border border-border rounded px-3 py-2 text-text-muted cursor-not-allowed opacity-60"
                      />
                    </div>
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        Pin Code
                      </label>
                      <input
                        type="text"
                        value={selectedAdmin.createPin || "N/A"}
                        disabled
                        className="w-full bg-bg-input/50 border border-border rounded px-3 py-2 text-text-muted cursor-not-allowed opacity-60"
                      />
                    </div>
                  </div>
                </div>

                {/* Admin Details Section - EDITABLE */}
                <div className="border border-signal-orange/30 rounded-lg p-4 bg-bg-tertiary/10">
                  <h3 className="text-sm font-bold text-signal-orange uppercase mb-3 flex items-center gap-2">
                    <FaEdit />
                    Admin Details
                  </h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        Admin Name *
                      </label>
                      <input
                        type="text"
                        value={selectedAdmin.adminName || ""}
                        onChange={(e) =>
                          handleEditChange("adminName", e.target.value)
                        }
                        className="w-full bg-bg-input border border-border rounded px-3 py-2 text-text-main focus:border-signal-orange focus:outline-none"
                      />
                    </div>
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        Email *
                      </label>
                      <input
                        type="email"
                        value={selectedAdmin.adminEmail || ""}
                        onChange={(e) =>
                          handleEditChange("adminEmail", e.target.value)
                        }
                        className="w-full bg-bg-input border border-border rounded px-3 py-2 text-text-main focus:border-signal-orange focus:outline-none"
                      />
                    </div>
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        Phone
                      </label>
                      <input
                        type="tel"
                        value={selectedAdmin.adminPhoneNo || ""}
                        onChange={(e) =>
                          handleEditChange("adminPhoneNo", e.target.value)
                        }
                        className="w-full bg-bg-input border border-border rounded px-3 py-2 text-text-main focus:border-signal-orange focus:outline-none"
                      />
                    </div>
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        Password
                      </label>
                      <div className="relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          value={selectedAdmin.createPassword || ""}
                          onChange={(e) =>
                            handleEditChange("createPassword", e.target.value)
                          }
                          className="w-full bg-bg-input border border-border rounded px-3 py-2 text-text-main focus:border-signal-orange focus:outline-none pr-10"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword((prev) => !prev)}
                          className="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted hover:text-text-main"
                        >
                          {showPassword ? "🙈" : "👁️"}
                        </button>
                      </div>
                    </div>
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        Start Date
                      </label>
                      <input
                        type="date"
                        value={
                          selectedAdmin.startDate
                            ? selectedAdmin.startDate.split("T")[0]
                            : ""
                        }
                        onChange={(e) =>
                          handleEditChange("startDate", e.target.value)
                        }
                        className="w-full bg-bg-input border border-border rounded px-3 py-2 text-text-main focus:border-signal-orange focus:outline-none"
                      />
                    </div>
                    <div>
                      <label className="text-xs font-bold text-text-muted uppercase mb-1 block">
                        End Date
                      </label>
                      <input
                        type="date"
                        value={
                          selectedAdmin.endDate
                            ? selectedAdmin.endDate.split("T")[0]
                            : ""
                        }
                        onChange={(e) =>
                          handleEditChange("endDate", e.target.value)
                        }
                        className="w-full bg-bg-input border border-border rounded px-3 py-2 text-text-main focus:border-signal-orange focus:outline-none"
                      />
                    </div>
                  </div>
                  <div className="flex items-center gap-2 pt-6">
                    <input
                      type="checkbox"
                      checked={!!selectedAdmin.societyMember}
                      onChange={(e) =>
                        handleEditChange("societyMember", e.target.checked)
                      }
                      className="accent-signal-orange cursor-pointer"
                    />
                    <span
                      className="text-text-main text-sm cursor-pointer"
                      onClick={() =>
                        handleEditChange(
                          "societyMember",
                          !selectedAdmin.societyMember,
                        )
                      }
                    >
                      Is Society Member
                    </span>
                  </div>
                </div>

                <div className="flex justify-end gap-4 pt-4 border-t border-border">
                  <button
                    onClick={closeEditModal}
                    className="px-4 py-2 text-text-muted hover:text-text-main"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={saveAdminChanges}
                    disabled={saving}
                    className="px-6 py-2 bg-signal-orange text-noir-900 font-bold rounded hover:bg-orange-400 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {saving ? "Saving..." : "Update Admin"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateSocietyAdminList;
